import { gameDefinitions, SupportedGames } from "@repo/game-configuration"
import { Locale } from "@repo/i18n"
import { LANGUAGE_NAMES } from "@/components/promotions/promotion-helpers"

const GAME_VALUES = new Set<string>(Object.values(SupportedGames))
const LOCALE_VALUES = new Set<string>(Object.values(Locale))

/** Whether a string is a supported game slug. */
export function isSupportedGame(value: string): value is SupportedGames {
	return GAME_VALUES.has(value)
}

/** Whether a string is a UI locale code. */
export function isLocale(value: string): value is Locale {
	return LOCALE_VALUES.has(value)
}

/** Display name of a game, falling back to its slug. */
export function gameLabel(game: string): string {
	return isSupportedGame(game) ? gameDefinitions[game].name : game
}

/** Display name of a language, falling back to its code. */
export function languageLabel(locale: string): string {
	return isLocale(locale) ? LANGUAGE_NAMES[locale] : locale
}

/** Games an app can be listed for, by name. */
export const APP_GAME_OPTIONS = Object.values(SupportedGames)
	.filter((game) => game !== SupportedGames.ExampleGame)
	.map((game) => ({ value: game, label: gameLabel(game) }))
	.sort((a, b) => a.label.localeCompare(b.label))

/** Languages an app can be listed as available in. */
export const APP_LANGUAGE_OPTIONS = Object.values(Locale).map((locale) => ({
	value: locale,
	label: languageLabel(locale),
}))
